module.exports = __webpack_public_path__ + "static/三方盒子（WJY、LZY）刷机教程v1.61309.c54ed671.png";